// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    get: `/${BASE_URL_BIDDING_SERVICE}/common/admin`,
};

const GetAdmins = (start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}`).then(callback).catch(error).finally(next);
};

export const AdminService = {
    GetAdmins,
};
